import MainCard from 'ui-component/cards/MainCard';
import { ReactNode } from 'react';

const MainCardWrapper = ({ children }: { children: ReactNode }) => (
  <MainCard>{children}</MainCard>
);

export default MainCardWrapper;
